// Agent runtime: conversation turns, tool execution, simulator, context bundles (PRD §8, §8.0, §8.2).
import * as R from './api-agent-runtime.js';
import { OkSchema } from './api.js';
import { IdParam, items, route, W, Ws } from './route-def.js';

const Sim = W({ simulationId: IdParam });
const Scenario = W({ scenarioId: IdParam });

export const agentRuntimeRoutes = {
  agentRuntimeStatus: route({
    method: 'GET', path: '/workspaces/:workspaceId/agent-runtime/status', summary: 'Estado del runtime del agente (proveedor de IA, herramientas)', tag: 'agent-runtime',
    minRole: 'manager', params: Ws, response: R.AgentRuntimeStatusSchema,
  }),

  agentLatencyStats: route({
    method: 'GET', path: '/workspaces/:workspaceId/agent-runtime/latency', summary: 'Latencia de los turnos del agente (p50/p95, turnos ordinarios vs. con herramientas)', tag: 'agent-runtime',
    minRole: 'manager', params: Ws, query: R.LatencyStatsQuerySchema, response: R.AgentLatencyStatsSchema,
  }),

  // ─────────── "Probar agente" simulator (sandboxed; never touches real leads) ───────────
  listSimulations: route({
    method: 'GET', path: '/workspaces/:workspaceId/simulations', summary: 'Simulaciones recientes', tag: 'agent-runtime',
    minRole: 'manager', params: Ws, query: R.SimulationListQuerySchema, response: items(R.SimulationSummarySchema),
  }),
  createSimulation: route({
    method: 'POST', path: '/workspaces/:workspaceId/simulations', summary: 'Iniciar una simulación del agente', tag: 'agent-runtime',
    minRole: 'manager', params: Ws, body: R.CreateSimulationSchema, response: R.SimulationSessionSchema, status: 201,
  }),
  getSimulation: route({
    method: 'GET', path: '/workspaces/:workspaceId/simulations/:simulationId', summary: 'Simulación con transcripción y trazas', tag: 'agent-runtime',
    minRole: 'manager', params: Sim, response: R.SimulationSessionSchema,
  }),
  sendSimulationMessage: route({
    method: 'POST', path: '/workspaces/:workspaceId/simulations/:simulationId/messages', summary: 'Enviar un mensaje de prueba y obtener la respuesta con su traza', tag: 'agent-runtime',
    minRole: 'manager', params: Sim, body: R.SendSimulationMessageSchema, response: R.SimulationSessionSchema,
  }),
  resetSimulation: route({
    method: 'POST', path: '/workspaces/:workspaceId/simulations/:simulationId/reset', summary: 'Reiniciar la simulación (la transcripción anterior queda guardada)', tag: 'agent-runtime',
    minRole: 'manager', params: Sim, response: R.SimulationSessionSchema,
  }),
  saveSimulationScenario: route({
    method: 'POST', path: '/workspaces/:workspaceId/simulations/:simulationId/scenario', summary: 'Guardar la simulación como escenario de prueba', tag: 'agent-runtime',
    minRole: 'manager', params: Sim, body: R.SaveScenarioSchema, response: R.TestScenarioSchema, status: 201,
  }),

  // ─────────── Reusable scenarios (PRD §8.0 "run representative scenarios") ───────────
  listTestScenarios: route({
    method: 'GET', path: '/workspaces/:workspaceId/test-scenarios', summary: 'Escenarios de prueba del agente', tag: 'agent-runtime',
    minRole: 'manager', params: Ws, query: R.TestScenarioListQuerySchema, response: items(R.TestScenarioSchema),
  }),
  updateTestScenario: route({
    method: 'PATCH', path: '/workspaces/:workspaceId/test-scenarios/:scenarioId', summary: 'Marcar o desmarcar «Debe pasar antes de activar cambios»', tag: 'agent-runtime',
    minRole: 'manager', params: Scenario, body: R.UpdateScenarioSchema, response: R.TestScenarioSchema,
  }),
  deleteTestScenario: route({
    method: 'DELETE', path: '/workspaces/:workspaceId/test-scenarios/:scenarioId', summary: 'Eliminar escenario', tag: 'agent-runtime',
    minRole: 'manager', params: Scenario, response: OkSchema,
  }),
  runTestScenarios: route({
    method: 'POST', path: '/workspaces/:workspaceId/test-scenarios/run', summary: 'Ejecutar escenarios (simulados, sin efectos reales)', tag: 'agent-runtime',
    minRole: 'manager', params: Ws, body: R.RunScenariosSchema, response: items(R.TestRunSchema),
  }),
  listTestRuns: route({
    method: 'GET', path: '/workspaces/:workspaceId/test-scenarios/:scenarioId/runs', summary: 'Ejecuciones de un escenario', tag: 'agent-runtime',
    minRole: 'manager', params: Scenario, response: items(R.TestRunSchema),
  }),
} as const;
